import { format, parseISO } from "date-fns"
import { FormComponent, FormComponentType } from "@components/FormBuilder/types"
import { DropdownOptions } from "@custom-types/common"
import { EditContractFormApi } from "@features/administration/contracts/EditContract/types"

type GetContractFormFieldsProps = {
  organisationOptions: DropdownOptions
  divisionOptions: DropdownOptions
}

export const getContractFormFields = ({
  organisationOptions = [],
  divisionOptions = [],
}: GetContractFormFieldsProps): Record<
  keyof Omit<EditContractFormApi, "product_families">,
  FormComponent
> & {
  product_families?: FormComponent // //  @TODO (Bartek Laskowski) 2025-10-02: remove Omit when field will be implemented on FE. Looks like it's ready to use by BE.
} => ({
  organisation_key: {
    title: "Organisation",
    editable: true,
    type: FormComponentType.Dropdown,
    options: organisationOptions,
  },
  division_key: {
    title: "Division",
    editable: true,
    type: FormComponentType.Dropdown,
    options: divisionOptions,
  },
  salesforce_id: {
    title: "Salesforce ID",
    editable: true,
    type: FormComponentType.Input,
  },
  salesforce_contact: {
    title: "Client Contact",
    editable: true,
    type: FormComponentType.Input,
  },
  salesforce_contact_email: {
    title: "Client Email",
    editable: true,
    type: FormComponentType.Input,
  },
  active: {
    title: "Active",
    editable: true,
    type: FormComponentType.Checkbox,
  },
  description: {
    title: "Description",
    editable: true,
    type: FormComponentType.Textarea,
  },
  sftp: {
    title: "SFTP",
    editable: true,
    type: FormComponentType.Input,
  },
  start_date: {
    title: "Start Date",
    editable: true,
    type: FormComponentType.Date,
    modifier: (value) => format(parseISO(value ? value : new Date().toISOString()), "dd/MM/yyyy"),
  },
  end_date: {
    title: "End Date",
    editable: true,
    type: FormComponentType.Date,
    modifier: (value) => format(parseISO(value ? value : new Date().toISOString()), "dd/MM/yyyy"),
  },
  download_results_enabled: {
    title: "Enable download results",
    editable: true,
    type: FormComponentType.Checkbox,
  },
  webhook_url: {
    title: "Webhook Url",
    editable: true,
    type: FormComponentType.Input,
  },
})
